import { axiosInstance, baseUrl, handleErrors } from "./auth";

export const CLIENT_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/clientList`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const CLIENT_BOOKING_LIST = async (params) => {
    try {        
        const response = await axiosInstance.post(`${baseUrl}/client/bookingList`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const CLIENT_PAYMENT_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/paymentManagementVendor`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const CLIENT_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/getDetail`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const TICKET_BOOKING_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/ticket/bookingList`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};